// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchUrl = exports.HubName = exports.LaunchBrowser = void 0;
class LaunchBrowser {
    static chrome = "pwa-chrome";
    static edge = "pwa-msedge";
}
exports.LaunchBrowser = LaunchBrowser;
class HubName {
    static teams = "Teams";
    static outlook = "Outlook";
    static office = "the Microsoft 365 app";
}
exports.HubName = HubName;
class LaunchUrl {
    static teamsLocal = "https://teams.microsoft.com/l/app/${localTeamsAppId}?installAppPackage=true&webjoin=true&${account-hint}";
    static teamsRemote = "https://teams.microsoft.com/l/app/${teamsAppId}?installAppPackage=true&webjoin=true&${account-hint}";
    static outlookLocalTab = "https://outlook.office.com/host/${localTeamsAppInternalId}?${account-hint}";
    static outlookRemoteTab = "https://outlook.office.com/host/${teamsAppInternalId}?${account-hint}";
    static outlookLocalBot = "https://outlook.office.com/mail?${account-hint}";
    static outlookRemoteBot = "https://outlook.office.com/mail?${account-hint}";
    static officeLocalTab = "https://www.office.com/m365apps/${localTeamsAppInternalId}?auth=2&${account-hint}";
    static officeRemoteTab = "https://www.office.com/m365apps/${teamsAppInternalId}?auth=2&${account-hint}";
}
exports.LaunchUrl = LaunchUrl;
//# sourceMappingURL=constants.js.map